// extracted by mini-css-extract-plugin
export default {"container":"VeterinarianStatus_container__UBRLq"};